export default {
  sku: 'GA06',
  common: {
    features: [
      'Scan unlimited files and folders',
      'Save Audit Logs in Google sheets',
    ],
  },
  standard: {
    name: 'Standard',
    price: '79.95',
    features: [
      'Audit Files in personal Google Drive',
      'Complimentary email support for 30 days',
    ],
  },
  enterprise: {
    name: 'Enterprise',
    price: '99.95',
    features: [
      'Audit Files in personal Google Drive',
      'Audit Files in Shared Google Drives',
      'Priority email support while subscribed',
      'One-on-one support (2 calls per annual billing cycle)',
    ],
  },
};
